// PaymentDetails.js: the information panel, built from the season settings (admin panel)
import React from "react";
import { formatDate, formatFee } from "../season";

const PaymentDetails = ({ season }) => {
  const { categories = [], payment = {}, coordinator = [] } = season;
  const withHeadings = categories.filter((c) => c.heading);

  return (
    <div className="p-4 bg-gray-100 rounded-lg shadow-md">
      {withHeadings.map((c, i) => (
        <React.Fragment key={c.code}>
          <h2 className={`text-lg font-bold mb-4 ${i > 0 ? "mt-6" : ""}`}>{c.heading}</h2>
          {c.grades && (
            <ul className="list-disc ml-8">
              <li className="text-lg">{c.grades}</li>
            </ul>
          )}
        </React.Fragment>
      ))}

      {withHeadings.length > 0 ? (
        <>
          <p className="text-lg font-bold mt-4 uppercase">
            Please read the following instructions before filling the form:
          </p>
          <h3 className="text-lg font-bold mt-4">Payment of Examination Fees</h3>
        </>
      ) : (
        <h2 className="text-lg font-bold mb-4 uppercase">Payment of Examination Fees</h2>
      )}
      <ul className="list-disc ml-8">
        {categories.map((c, i) => (
          <li key={c.code} className={`text-lg ${i > 0 ? "mt-2" : ""}`}>
            Rs. {formatFee(c.fee)} for {c.feeDescription}
          </li>
        ))}
      </ul>

      <p className="text-lg mt-4 uppercase font-bold">Should be deposited into</p>
      <div className="ml-4 mt-3">
        <p><strong>Account Name:</strong> {payment.accountName}</p>
        <p><strong>Account Number:</strong> {payment.accountNumber}</p>
        <p><strong>Bank:</strong> {payment.bank}</p>
        <p><strong>Branch:</strong> {payment.branch}</p>
      </div>

      {payment.instructions && <p className="mt-4">{payment.instructions}</p>}

      <p className="text-lg mt-4">
        <strong>The deadline to send the payment and application form</strong>
      </p>
      <ul className="list-disc ml-8">
        <li className="text-lg">{formatDate(season.deadline)}</li>
      </ul>

      {coordinator.length > 0 && (
        <>
          <p className="text-lg mt-4"><strong>{coordinator[0]}</strong></p>
          {coordinator.slice(1).map((line) => (
            <p key={line} className="text-lg">{line}</p>
          ))}
        </>
      )}

      {season.assistanceEmail && (
        <>
          <p className="text-lg mt-4"><strong>For Registration Assistance</strong></p>
          <p className="text-lg">{season.assistanceEmail}</p>
        </>
      )}

      {season.detailsUrl && (
        <>
          <p className="text-lg mt-4"><strong>OLYMPIAD COMPETITION DETAILS</strong></p>
          <p className="p-2 bg-yellow-600 text-white rounded">
            <a href={season.detailsUrl} target="_blank" rel="noreferrer">CLICK HERE</a>
          </p>
        </>
      )}
    </div>
  );
};

export default PaymentDetails;
